// @flow

import Loadable from 'react-loadable'

/* prettier-ignore */
export default Loadable({
  loader: () => import(`./container` /* webpackChunkName: "editor-toolbar" */),
  loading: () => null,
});
